import { LIST_SORT_OPTIONS } from 'src/components/list/helpers/sortOptions'
import { getListQueryParamName, getListQueryParamValue, translateListQueryParamValue } from './listQueryParams'

// Wyszukiwarka ma na początku trafność, a dalej ten sam zestaw co listy publikacji.
export const SEARCH_SORT_OPTIONS = [{ value: 'relevance', labelKey: 'T_SORT_RELEVANCE' }, ...LIST_SORT_OPTIONS]

const SEARCH_SORT_VALUES = new Set(SEARCH_SORT_OPTIONS.map((option) => option.value))

export const normalizeSearchSort = (value) => (SEARCH_SORT_VALUES.has(value) ? value : 'relevance')

export const getSearchSortParams = (sortValue) => {
  switch (normalizeSearchSort(sortValue)) {
    case 'title-asc':
      return { sort: 'title', order: 'asc' }
    case 'title-desc':
      return { sort: 'title', order: 'desc' }
    case 'newest':
      return { sort: 'publishedAt', order: 'desc' }
    case 'oldest':
      return { sort: 'publishedAt', order: 'asc' }
    default:
      return {}
  }
}

export const getSearchSortOptions = (translateEntry) =>
  SEARCH_SORT_OPTIONS.map((option) => ({ ...option, label: translateEntry(option.labelKey) }))

// Sortowanie w adresie ma zlokalizowaną nazwę i wartość (np. `sortowanie=najnowsze`), tak jak na listach.
export const readSearchSortParam = (searchParams, locale) => {
  const value = getListQueryParamValue(searchParams, 'sort', locale)

  return normalizeSearchSort(translateListQueryParamValue('sort', Array.isArray(value) ? value[0] : value, 'en'))
}

export const setSearchSortParam = (params, sortValue, locale) => {
  const safeSortValue = normalizeSearchSort(sortValue)

  if (safeSortValue !== 'relevance') {
    params.set(getListQueryParamName('sort', locale), translateListQueryParamValue('sort', safeSortValue, locale))
  }
}
